import React from "react";
import styled from "styled-components";
import { shallowEqual, useSelector } from "react-redux";
import { useParams } from "react-router-dom"
import headerIcon from "./../assets/rfpPlaidMazooma.svg";
import errorIcon from "./../assets/rfpErrorIcon.svg";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 18px 32px 24px 32px;
`;

const Header = styled.img`
  height: 20px;
  padding-bottom: 144px;
`;

const ErrorIcon = styled.img`
  height: 96px;
  padding-bottom: 32px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
  padding-bottom: 16px;
`;

const Description = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  padding-bottom: 16px;
`;

const Suggestion = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
`;

const Button = styled.button`
  margin-top: auto;
  color: white;
  background: #111111;
  border-radius: 2px;
  height: 56px !important;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
`;

export const RFPErrorPage = () => {
  const appStore = useSelector((state) => state, shallowEqual).app;
  const { accountSubType, accountNumberMask, merchantName, merchantReturnUrl } = appStore;
  const { errorId } = useParams();
  const accountDetails = () => {
    return (
      <div>
        {`Selected account: ${accountSubType.charAt(0).toUpperCase() + accountSubType.slice(1)} 
                     ****** ${accountNumberMask}.`}
      </div>
    );
  };
  const returnToMerchant = () => {
    window.location.href = merchantReturnUrl;
  }
  const errorTemplates = {
    default: {
      title: "Sorry, the transaction could not be completed",
      description: <div>No money was exchanged.</div>,
      suggestion: "Go back to the merchant and try again.",
    },
    timeout: {
      title: "Sorry, your deposit timed out",
      description: (
        <>
          <div>We did not receive a payment confirmation from your bank.</div>
          {accountDetails()}
          <div>No money was exchanged.</div>
        </>
      ),
      suggestion: "Go back to the merchant and try again.",
    },
    cancelled: {
      title: "Your deposit was cancelled.",
      description: (
        <>
          <div>You did not accept the payment request from your bank.</div>
          {accountDetails()}
          <div>No money was exchanged.</div>
        </>
      ),
      suggestion: "Go back to the merchant and try again.",
    },
    rejected: {
      title: "Sorry, the transaction could not be completed.",
      description: (
        <>
          {accountDetails()}
          <div>No money was exchanged.</div>
        </>
      ),
      suggestion: "Go back to the merchant and try again with another bank account.",
    },
  };

  const errorKey = errorTemplates[errorId] === undefined ? "default" : errorId;
  const errorTemplate = errorTemplates[errorKey];

  return (
    <PageWrapper>
      <Header src={headerIcon} />
      <ErrorIcon src={errorIcon} />
      <Title>{errorTemplate.title}</Title>
      <Description>{errorTemplate.description}</Description>
      <Suggestion>{errorTemplate.suggestion}</Suggestion>
      <Button onClick={returnToMerchant}>Back to {merchantName}</Button>
    </PageWrapper>
  );
}

export default RFPErrorPage;